import Vue from 'vue';
import {isMobile, isTablet} from 'mobile-device-detect';

Vue.mixin({
  computed: {
    apiUrl() {
      return process.env.VUE_APP_BASE_API_URL;
    },
    shopId() {
      return this.$store.getters.SHOP_ID;
    },
    coreParams() {
      return this.$store.getters.CORE_PARAMS;
    },
    user() {
      return this.$store.getters.USER;
    },
    uuid() {
      return this.$store.getters.UUID;
    },
    mass() {
      return this.$store.getters.MASS;
    },
    prevRoute() {
      return this.$store.getters.PREV_ROUTE;
    },
    album() {
      return this.$store.getters.ALBUM;
    },
    albumPhotos() {
      return this.$store.getters.ALBUM_PHOTOS;
    },
    albumCategories() {
      return this.$store.getters.ALBUM_CATEGORIES;
    },
    albums() {
      return this.$store.getters.ALBUMS;
    },
    customerItems() {
      return this.$store.getters.CUSTOMER_ITEMS;
    },
    customerAlbums() {
      return this.$store.getters.CUSTOMER_ALBUMS;
    },
    products() {
      return this.$store.getters.PRODUCTS;
    },
    cart() {
      return this.$store.getters.CART;
    },
    myOrder() {
      return this.$store.getters.ORDER;
    },
    myOrderPhotos() {
      return this.myOrder ? this.myOrder.photos : [];
    },
    tmpOrder() {
      return this.$store.getters.TMP_ORDER;
    },
    set() {
      return this.$store.getters.SET;
    },
    productSet() {
      return this.$store.getters.PRODUCT_SET;
    },
    sets() {
      return this.$store.getters.SETS;
    },
    bulkPrice() {
      return this.$store ? this.$store.getters.BULK_PRICE : null;
    },
    pricelists() {
      return this.$store.getters.PRICELISTS;
    },
    photo() {
      return this.$store.getters.PHOTO;
    },
    photos() {
      return this.album ? this.album.album_items : [];
    },
    headerBackground() {
      return this.album.primary_photo
          ? this.album.primary_photo.large_photo_clean
          : this.album.first_photo
              ? this.album.first_photo.large_photo_clean
              : null;
    },
    checkout() {
      return this.$store.getters.CHECKOUT;
    },
    favorites() {
      return this.$store.getters.FAVORITES;
    },
    product() {
      return this.myOrder ? this.myOrder.product : null;
    },
    productItem() {
      return this.myOrder ? this.myOrder.productItem : null;
    },
    orderStep() {
      return this.$store ? this.$store.getters.ORDER_STEP : null;
    },
    lastPrevStep() {
      return this.$store.getters.LAST_PREV_ORDER_STEP;
    },
    checkoutStep() {
      return this.$store.getters.CHECKOUT_STEP;
    },
    downloads() {
      return this.$store.getters.DOWNLOADS
          ? this.$store.getters.DOWNLOADS
          : 0;
    },
    salutationOptions() {
      return [
        {value: 'Mr.', text: this.$t('salutation.mr')},
        {value: 'Ms.', text: this.$t('salutation.ms')},
      ];
    },
    countryOptions() {
      return this.$store.getters.COUNTRY_OPTIONS
          ? this.$store.getters.COUNTRY_OPTIONS
          : [];
    },
    shippingOptions() {
      return this.$store.getters.SHIPPING_OPTIONS;
    },
    paymentOptions() {
      return this.$store.getters.PAYMENT_OPTIONS;
    },
    paymentConfigs() {
      return this.$store.getters.PAYMENT_CONFIGS;
    },
    currentRoutePath() {
      return this.$route.path;
    },
    invoices() {
      return this.$store.getters.INVOICES;
    },
    vat() {
      const shopCompanyInfo = this.$store.getters.CORE_PARAMS.shop_company_info;

      if (this.cart) {
        let total = +this.cart.total || 0;

        if ('checkout' === this.$route.name) {
          total = +this.tmpOrder.grandtotal;
        }

        if (+shopCompanyInfo.tax_obligation && shopCompanyInfo.percent_tax) {
          return total - (total / (1 + +shopCompanyInfo.percent_tax.percent_value));
        }
      }

      return 0;
    },
    coupon() {
      return this.$store.getters.COUPON;
    },
    drawing() {
      return this.$store.getters.DRAWING;
    },
    completedDrawing() {
      return this.$store.getters.COMPLETED_DRAWING;
    },
    isMobile() {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.platform) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

      return isMobile || isIOS;
    },
    isTablet() {
      return isTablet;
    },
  },
});
